export { isAppManifest } from './appManifest/isAppManifest';
export { parseAppManifest } from './appManifest/parseAppManifest';
export type {
  SplashScreenModeSpec,
  SplashScreenResizeMode,
  SplashScreenSpec,
} from './appManifest/splashScreen';
export type { AppManifestParseResult } from './types/appManifest';
